import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "How to tell a phone your website is an app",
  "description": "",
  "published": "2012-11-05T00:00:00.000Z",
  "redirect_from": ["/blog/how-to-tell-a-phone-your-website-is-an-app/swizec/5503"],
  "categories": "Address bar, HTML, IPhone, Meta element, Uncategorized, Website",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`I don't always get to work on mobile projects, but when I do they're websites pretending to be apps.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/11/default-bootstrap-example.png",
        "alt": "Default bootstrap example - zoomable etc.",
        "title": "Default bootstrap example - zoomable etc."
      }}></img></p>
    <p>{`So the question is: If your schedule is too tight to get a simple phonegap application through the approval process, how do you deliver a great mobile experience to users on launch day?`}</p>
    <p>{`Responsive design will only get you so far. Which is to say not very far at all.`}</p>
    <p>{`Take Bootstrap, use all the responsive features and you are left with a website that looks a bit different on a phone than it does on a computer or a tablet. But it's no app.`}</p>
    <ul>
      <li parentName="ul">{`renders super small despite the `}<em parentName="li">{`initial-scale=1.0`}</em>{` `}<a parentName="li" {...{
          "href": "http://en.wikipedia.org/wiki/Meta_element",
          "title": "Meta element"
        }}>{`meta tag`}</a></li>
      <li parentName="ul">{`scrolls all over the place`}</li>
    </ul>
    <p>{`First step to fixing things is disabling user scalability:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<meta
  name="viewport"
  content="width=device-width, initial-scale=1.0, user-scalable=no, maximum-scale=1.0"
/>
`}</code></pre>
    <p>{`Default zooming is okay now and users can't `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Multi-touch_gestures",
        "title": "Multi-touch gestures"
      }}>{`pinch-to-zoom`}</a>{` anymore. But they can still do plenty of strange side-scrolling and bouncing around. Something apps don't usually do.`}</p>
    <p>{`Adding another meta tag fixes that problem.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<meta name="apple-mobile-web-app-capable" content="yes" />
`}</code></pre>
    <p>{`Our only problem now is that pesky `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Address_bar",
        "title": "Address bar"
      }}>{`address bar`}</a>{` on the top. Apps don't have that! This can be solved with a bit of simple javascript:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`// When ready...
window.addEventListener("load", function () {
  // Set a timeout...
  setTimeout(function () {
    // Hide the address bar!
    window.scrollTo(0, 1);
  }, 0);
});
`}</code></pre>
    <p>{`Marvelous! You even get an extra 60 pixels of room to play with.`}</p>
    <p>{`Just keep in mind that you `}<em parentName="p">{`must`}</em>{` use those 60 pixels, otherwise the address bar won't hide because there's nothing to scroll up.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/11/app-like-bootstrap-example.png",
        "alt": "Final result - an app-like website",
        "title": "Final result - an app-like website"
      }}></img></p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.covario.com/2012/10/a-revival-of-the-meta-tag/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/noimg_34_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://www.covario.com/2012/10/a-revival-of-the-meta-tag/"
        }}>{`A Revival of the Meta Tag`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://blog.markedup.com/2012/10/making-the-connection-lighting-up-metro-ies-ability-direct-link-to-an-app-in-the-windows-store/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/119697768_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://blog.markedup.com/2012/10/making-the-connection-lighting-up-metro-ies-ability-direct-link-to-an-app-in-the-windows-store/"
        }}>{`Making the Connection: Lighting up Metro IE's Ability Direct Link to an App in the Windows Store`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.cultofmac.com/198658/view-more-of-a-webpage-on-your-iphone-with-full-screen-safari-ios-tips/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/122040643_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://www.cultofmac.com/198658/view-more-of-a-webpage-on-your-iphone-with-full-screen-safari-ios-tips/"
        }}>{`View More Of A Webpage On Your iPhone With Full Screen Safari `}{`[`}{`iOS Tips`}{`]`}</a></li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=88ec1abc-870f-41cc-b147-79fc75c1796b",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      